import { Formik, Form } from 'formik';

import { AppHeaderDefault, BaseBox } from '..';
import { HalfPageLayout } from '../HalfPageLayout/HalfPageLayout';

import './UserCommonView.scss';

const UserCommonViewContent = ({ children, heading, subheading, initialFormValues, onSubmit, validationSchema }) => (
  <div className="row">
    <div className="col-2" />
    <div className="col-8">
      <div className="user-common-view__title">
        <h1 className="heading heading--primary heading--color-primary">{heading}</h1>
        <p>{subheading}</p>
      </div>
      <Formik initialValues={initialFormValues} onSubmit={onSubmit} validationSchema={validationSchema}>
        <BaseBox className="user-common-view__box" borderless>
          <Form className="form-container">{children}</Form>
        </BaseBox>
      </Formik>
    </div>
    <div className="col-2" />
  </div>
);

const UserCommonView = (props) => {
  const {
    children,
    heading,
    subheading,
    initialFormValues,
    onSubmit,
    validationSchema,
    isAdvisor,
    leftContent = null,
  } = props;

  return (
    <AppHeaderDefault isAdvisor={isAdvisor}>
      <div className="user-common-view__content">
        <HalfPageLayout
          leftContent={leftContent}
          rightContent={
            <UserCommonViewContent
              heading={heading}
              subheading={subheading}
              initialFormValues={initialFormValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
              {children}
            </UserCommonViewContent>
          }
        />
      </div>
    </AppHeaderDefault>
  );
};

export default UserCommonView;
